module.exports = __webpack_public_path__ + "static/media/igy_logo.59a63200.svg";